<template lang="html">
  <router-view />
</template>

<script>
export default {
	name: 'IndexRouter'
}
</script>

<style lang="css">
</style>



// WEBPACK FOOTER //
// index.vue?e51359be